import z from 'zod';

import { calculateAge, dateInvalid } from './date-parser';

// .trim() runs before the checks that follow it, so leading/trailing whitespace
// is stripped from the parsed value instead of failing validation
export const nameSchema = z
	.string()
	.trim()
	.regex(/^[a-z]+$/i);

export const requiredDateSchema = z.date({ invalid_type_error: 'Required' });

const dateWithinRange = (message: string, minYears: number, maxYears: number | undefined = undefined) => {
	return z.date({ invalid_type_error: 'Date of Birth is a required property' }).refine(
		(val) => {
			if (dateInvalid(val)) {
				return false;
			}

			const yearsSinceDate = calculateAge(new Date(val));

			if (minYears && maxYears) {
				return yearsSinceDate >= minYears && yearsSinceDate <= maxYears;
			}

			return yearsSinceDate >= minYears;
		},
		{ message }
	);
};

// Export for testing purposes
export { dateWithinRange };

export const patientDateOfBirth = dateWithinRange('Patient age must be 1-150 years old.', 1, 150);

export const requiredAdultDoB = dateWithinRange('Age must be 18-150', 18, 150);

export const zipCodeSchema = {
	required: z.string().regex(/\d{5}/),
	optional: z.string().optional(),
};

export const emailSchema = z.string().min(5);
